var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`fg-numeric form-group ${_vm.hasLabel}`},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('el-input-number',_vm._g(_vm._b({class:`form-control valid ${_vm.isPercentage} ${_vm.inputClasses}`},'el-input-number',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }